import React from 'react';
import PropTypes from 'prop-types';
import filter from 'ramda/src/filter';
import includes from 'ramda/src/includes';
import cx from 'classnames';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { LibraryTypes, LibraryProgramMenu } from '~/services/config';
import { removeAssign } from '~/services/util';

const ClosedList = ({ 
    role = 1, 
    name = '', 
    description = '', 
    thumbnail, 
    type = 'careers', 
    modules = 0, 
    quotas, 
    quotasCount, 
    courseCount, 
    length, 
    published, 
    onToggle = () => {}, 
    onChange = () => {}, 
    dataCy 
}) => {
    const dotsMenu = type === 'habits' ? filter((x) => !includes('Assign', x), LibraryProgramMenu[role]) : LibraryProgramMenu[role];
    const options = removeAssign(dotsMenu, published);
    return (
        <div className="library-programs-list p-0" data-cy={dataCy}>
            <div className="programs-closed-list">
                <div className="list-detail" onClick={onToggle}>
                    <Thumbnail source={thumbnail ? thumbnail : LibraryTypes[type].icon} label={LibraryTypes[type].label} />
                    <div className={cx('d-flex ssm-column d-flex-1 ms-4 list-detail-info', type)}>
                        <div className="d-flex-5">
                            <p className="dsl-b16 text-400 mb-1 text-truncate word-break pe-3" data-cy="name">
                                {name}
                            </p>
                            <p className="dsl-b16 mb-0 text-truncate word-break pe-3" data-cy="description">
                                {description}
                            </p>
                        </div>

                        {type === 'scorecards' ? (
                            <>
                                <div className="d-flex-1 ms-4">
                                    <p className="dsl-b16 mb-0 text-nowrap ms-5 ps-3">{quotas.length}</p>
                                </div>
                                <div className="d-flex-1 ms-4">
                                    <p className="dsl-b16 mb-0 text-nowrap ms-4 ps-3">{modules}</p>
                                </div>
                            </>
                        ) : type === 'certifications' || type === 'careers' ? (
                            <>
                                <div className="ml-4 d-flex-1">
                                    <p className="dsl-b16 mb-0 text-nowrap ms-3">{quotasCount}</p>
                                </div>
                                <div className="ml-4 d-flex-1">
                                    <p className="dsl-b16 mb-0 text-nowrap ms-4">{courseCount}</p>
                                </div>
                                <div className="ml-4 d-flex-1">
                                    <p className="dsl-b16 mb-0 text-nowrap ms-4 ps-2">{modules}</p>
                                </div>
                            </>
                        ) : (
                            <div className="d-flex-1 flex-md-column">
                                <p className="dsl-b16 mb-0 ms-4">{modules}</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className={cx('edit', length > 2 && 'editDropdownScroll')} data-cy="editDropdown">
                    <EditDropdown options={options} onChange={onChange} />
                </div>
            </div>
        </div>
    );
};

ClosedList.propTypes = {
    role: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    type: PropTypes.string,
    modules: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    quotas: PropTypes.array,
    quotasCount: PropTypes.number,
    courseCount: PropTypes.number,
    length: PropTypes.number,
    published: PropTypes.number,
    onToggle: PropTypes.func,
    onChange: PropTypes.func,
    dataCy: PropTypes.string,
};

export default ClosedList;
